import React from 'react'
import CountryData from './CountryData.json'
import './customSelect.css'
function CustomSelectInput({selectedBank,handleSelectedOption,data}) {
    const allCountryData =CountryData
  
    return (
        <div className="bank-list" >
          <div className="modal-container">
            <div className="scrollable-list">
              {data.map((bank) => ( 
                <div
                  key={bank.id}
                  className={`icon-bank ${bank.name === selectedBank?.name ? "" : ""}`}
                  onClick={() => handleSelectedOption(bank)}
                >
                  <div className="bank-name-icon">
                   
                    <h2 className="bank-name">{bank.name}</h2>
            
                    {bank.name === selectedBank && (
                      <img
                        src="/images/global/bank-check.svg"
                        alt="check"
                      />
                    )}
                  </div>
                 
                </div>
              ))}
            </div>
          </div>
          {/* ... */}
        </div>
      )
 
}

export default CustomSelectInput